import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { ProjectCard } from "./ProjectCard";
import { projects } from "../data/projects";
import { staggeredContainer } from "../utils/animations";
import GitHubIcon from "@mui/icons-material/GitHub";

export const ProjectsSection = () => {
  const theme = useTheme();

  const onHoverStyle = {
    "&:hover": {
      "& svg": {
        color: "secondary.main",
      },
    },
  };

  return (
    <Box sx={{ py: 8, backgroundColor: "background.paper" }}>
      <Container maxWidth="lg">
        <motion.div
          variants={staggeredContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "space-between" },
              alignItems: "center",
              mb: 6,
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", md: "2.5rem" },
                fontWeight: 600,
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              Latest Side Projects
            </Typography>
            <Button
              variant="outlined"
              component="a"
              startIcon={<GitHubIcon />}
              href="https://github.com/cperault"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: { xs: "none", sm: "flex" },
                backgroundColor: "primary",
                boxShadow: theme.shadows[4],
                ...onHoverStyle,
              }}
            >
              View More on GitHub
            </Button>
          </Box>

          <Grid container spacing={2} sx={{ mb: { xs: 8, md: 0 } }}>
            {projects.slice(0, 2).map((project, index) => (
              <Grid item xs={12} md={6} key={project.title}>
                <ProjectCard {...project} index={index} />
              </Grid>
            ))}
          </Grid>

          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Button
              variant="outlined"
              component="a"
              startIcon={<GitHubIcon />}
              href="https://github.com/cperault"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "primary",
                boxShadow: theme.shadows[4],
              }}
            >
              View More on GitHub
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};
